import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import DownloadSection from './components/DownloadSection';
import CategoryPreview from './components/CategoryPreview';
import ArticlePreview from './components/ArticlePreview';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureSection />
        <DownloadSection />
        <CategoryPreview />
        <ArticlePreview />
        <FAQSection />
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "91影视看片app - 免费高清影视在线观看",
            "description": "91影视看片app提供安卓版、苹果版最新版本安装包免费下载。随时随地高清看片不缓冲，畅享免费影视在线观看体验。",
            "url": "https://www.91yingshi.com/",
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.91yingshi.com/" }
              ]
            }
          })
        }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              { "@type": "Question", "name": "91影视看片app是免费的吗？", "acceptedAnswer": { "@type": "Answer", "text": "是的，91影视看片app完全免费使用，所有影视内容均可免费在线观看。" } },
              { "@type": "Question", "name": "91影视看片app支持哪些手机系统？", "acceptedAnswer": { "@type": "Answer", "text": "全面支持安卓（Android 7.0及以上）和苹果iOS（iOS 13.0及以上）系统。" } },
              { "@type": "Question", "name": "如何下载安装91影视看片app？", "acceptedAnswer": { "@type": "Answer", "text": "在本页面点击对应的下载按钮获取安装包。安卓用户下载APK文件后直接安装；苹果用户可通过企业签名链接安装。" } },
              { "@type": "Question", "name": "91影视看片app安全吗？", "acceptedAnswer": { "@type": "Answer", "text": "91影视看片app经过多重安全检测，无毒无插件，所有安装包均通过主流安全软件检测认证。" } },
            ]
          })
        }} />
      </main>
      <Footer />
    </>
  );
}